module.exports = __webpack_public_path__ + "img/11-4.4d95e239.jpg";